import React, { useMemo } from 'react'
import { getCodeSetLabelFromList } from '../../../Functions/CodeSetFns'
import { Typography } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-pro'
import { useReportContext } from '../../../Contexts/Modules/ReportModule'

export function useWeaningReportCols() {
  const {
    trafficLightQuery,
    tissueTypeQuery,
    genotypeServiceQuery,
    weaningCullChoiceQuery,
    breeedingChoiceQuery,
  } = useReportContext()

  return useMemo<GridColDef[]>(
    () => [
      {
        headerName: 'Short Line Name',
        field: 'ShortLineName',
      },
      {
        headerName: 'DOB of Litters',
        field: 'DOB',
        renderCell: ({ value }) => (value ? value.substring(0, 10) : ''),
        valueFormatter: (value?: string) =>
          value ? value.substring(0, 10) : '',
      },
      {
        headerName: 'Age (days)',
        field: 'Age',
      },
      {
        headerName: 'Traffic Light',
        field: 'trafficlightcolour',
        valueFormatter: (value: any) =>
          getCodeSetLabelFromList(trafficLightQuery.data, value),
        renderCell: ({ value }) =>
          getCodeSetLabelFromList(trafficLightQuery.data, value),
      },
      {
        headerName: 'BPID',
        field: 'bpid',
      },
      {
        headerName: 'Litter Seq',
        field: 'litterseq',
      },
      {
        headerName: 'No of pups',
        field: 'borncount',
      },
      {
        headerName: 'Zone Name',
        field: 'zonename',
      },
      {
        headerName: 'Owner Facility',
        field: 'FacilityOwner',
      },
      {
        headerName: 'Rack Name',
        field: 'rackname',
      },
      {
        headerName: 'Rack ID',
        field: 'rackid',
      },
      {
        headerName: 'Tis Type',
        field: 'TissueCollectionType',
        valueFormatter: (value: any) =>
          getCodeSetLabelFromList(tissueTypeQuery.data, value),
        renderCell: ({ value }) =>
          getCodeSetLabelFromList(tissueTypeQuery.data, value),
      },
      {
        headerName: 'Genotype Service',
        field: 'GenotypeService',
        valueFormatter: (value: any) =>
          getCodeSetLabelFromList(genotypeServiceQuery.data, value),
        renderCell: ({ value }) =>
          getCodeSetLabelFromList(genotypeServiceQuery.data, value),
      },
      {
        headerName: 'Tis Comment ',
        field: 'TissueCollectionComments',
        valueFormatter: (value: any) =>
          getCodeSetLabelFromList(tissueTypeQuery.data, value),
        renderCell: ({ value }) =>
          getCodeSetLabelFromList(tissueTypeQuery.data, value),
      },
      {
        headerName: 'ID Comment',
        field: 'IdentificationComments',
      },
      {
        headerName: 'Cull at Wean',
        field: 'WeaningAtCull',
      },
      {
        headerName: 'Weaning Cull Choice',
        field: 'WeaningCullChoice',
        valueFormatter: (value: any) =>
          getCodeSetLabelFromList(weaningCullChoiceQuery.data, value),
        renderCell: ({ value }: any) =>
          getCodeSetLabelFromList(weaningCullChoiceQuery.data, value),
      },
      {
        headerName: 'These pairs only',
        field: 'WeaningNominatePairs',
      },
      {
        headerName: 'Breeding Choice',
        field: 'BreedingChoice',
        valueFormatter: (value: any) =>
          getCodeSetLabelFromList(breeedingChoiceQuery.data, value),
        renderCell: ({ value }: any) =>
          getCodeSetLabelFromList(breeedingChoiceQuery.data, value),
      },
      {
        headerName: 'End Of Breeding',
        field: 'EndOfBreeding',
        renderCell: ({ value }: any) => (
          <Typography sx={{ whiteSpace: 'normal', fontSize: '0.7rem' }}>
            {value}
          </Typography>
        ),
      },
    ],
    [
      trafficLightQuery,
      tissueTypeQuery,
      genotypeServiceQuery,
      weaningCullChoiceQuery,
      breeedingChoiceQuery,
    ],
  )
}
